import { render } from "./forget.vue?vue&type=template&id=15857272&scoped=true"
import script from "./forget.vue?vue&type=script&lang=js"
export * from "./forget.vue?vue&type=script&lang=js"

import "./forget.vue?vue&type=style&index=0&id=15857272&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-15857272"

export default script